export const SHOW_MODAL = "[INVESTIGATION REPORT] SHOW EDIT MODAL";
export const HIDE_MODAL = "[INVESTIGATION REPORT] HIDE EDIT MODAL";
export const SHOW_MODAL_CONFIRM = "[INVESTIGATION REPORT] SHOW CONFIRM MODAL";
export const HIDE_MODAL_CONFIRM = "[INVESTIGATION REPORT] HIDE CONFIRM MODAL";
